import { Component, OnInit, AfterViewInit , Input} from '@angular/core';
import {CommonService} from "../common.service";
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-staff-talk',
  templateUrl: './staff-talk.component.html',
  styleUrls: ['./staff-talk.component.css']
})
export class StaffTalkComponent implements OnInit, AfterViewInit {
    @Input() talk:string;
    @Input() picture:number;
    isHarmonyOS = false; //是否鸿蒙系统
  constructor(private commonService: CommonService) { }

  ngOnInit() {
    this.isHarmonyOS = this.commonService.isHarmonyOS();
  }

  ngAfterViewInit(){
      var htmlFontSize=document.documentElement.clientWidth/7.5;
      document.documentElement.style.fontSize=htmlFontSize+"px";

      if(this.talk.length>13){
          $(".talk_item").last().width($("#test").width());
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/staff-talk/staff-talk.component.ts